var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarHomme1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 494 494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-17{fill:none;}.cls-2{fill:#fed766;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#f8f8ff;}.cls-5{fill:#cfcfe2;}.cls-6{fill:#ef9a95;}.cls-7{fill:#394053;}.cls-8{fill:#2d3047;}.cls-9{fill:#f1f1ff;}.cls-10{fill:#ffc7ef;}.cls-11{fill:#e8a3d8;}.cls-12{fill:#ff715b;}.cls-13{fill:#ea4e3d;}.cls-14{fill:#aa6396;}.cls-15{fill:#304c03;}.cls-16{fill:#ffcac5;}.cls-17{stroke:#ffaea6;stroke-miterlimit:10;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 247,
    cy: 247,
    r: 247
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MinDef_ILLU_vectorisation_v3_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_5",
    "data-name": "Calque 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grand_gar\\xE7on",
    "data-name": "Grand gar\\xE7on"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 247,
    cy: 247,
    r: 247
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61,398c5.51-53.17,23.35-67.74,28-71s18.37-11.42,36-17a189,189,0,0,1,20-5c14.3-2.87,25.29-3.33,30-4,30-4.25,45-6.28,63-6,10.75.17,28.84,3.74,65,11,43.67,8.77,50.89,11.72,58,18,3.76,3.33,11.58,11.2,21,45,9.05,32.47,23.07,85.39,4,150-2.27,7.68-3.4,11.52-5,15-32.71,71.23-203.44,112.84-283,31C48.89,514.49,56.89,437.66,61,398Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M126,310l-15,6-3,199,14-1Q124,412,126,310Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M325.78,310.11,344,315l2.22,199.89-14-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M202.81,234.74c-8.33,13.28.56,20-6.81,44.26-5.85,19.3-13.87,23-12.16,35.17,1.43,10.13,8.18,21.66,18.38,25.49,12.08,4.53,16.27-6.42,33.78-3.66,13.16,2.08,24.56,10.44,29.64,5.44a6.49,6.49,0,0,0,.63-.75c1.63-2.09,4.47-7.35,7.67-26.52,5.17-31,7.76-46.52,1.18-64-3.31-8.84-10.94-29.14-29.63-33.79C229.07,212.29,210.84,221.94,202.81,234.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M231,369q-3,24-6,48-5.62,45.5-11,91l31,1-3-141Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M247,334.28c-1.27-.33-3.56-.34-7.16,2.57h-9.51l-7-2.57A40.11,40.11,0,0,0,220,350c-.1,14.05,7.41,23.9,10,27l14-1a34,34,0,0,0,9-16C255.41,349.62,253,335.86,247,334.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M272,269l25,32a179.68,179.68,0,0,1-40,86l-21-51c3-.57,22-4.57,33-23C281.26,292.39,273,271.31,272,269Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M233.82,58.55c29.88-5,53.92,8.47,59.6,11.92l.86.53c9.55,5.94,25.39,15.8,34.72,32a63.82,63.82,0,0,1,8,25c3.7,15.14,2.14,25.92,0,33-1.7,5.61-4.08,8.51-5,15-1.66,11.68,2.81,20.88,4,24,9.61,25.28-29.26,93.1-70,93-7.93,0-21.95-7-50-21-11.56-5.76-16.24-8.89-21-14-10-10.77-7.45-18.91-15-34-9.72-19.42-19.65-18.41-27-33-9.33-18.53-2.91-39.19,1.39-53C163.56,108.47,190.85,65.78,233.82,58.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M281,163c2.49-.09,4,7.85,11,29,2.85,8.57,5.35,15.51,7,20a11.16,11.16,0,0,1-3,7c-4,3.95-10.38,2.71-14,2-3.15-.61-11.27-2.2-14-8-2.25-4.78.66-9.26,4-18C279.6,175.11,278,163.12,281,163Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M262.69,139c2.08,4.7,3.7,10.32.74,13-3.11,2.81-9.54.87-16.35,0-8-1-19.3-.89-33.77,4a6.8,6.8,0,0,1-1.2-5c1.55-7.11,18.32-9.73,26.44-11A107.67,107.67,0,0,1,262.69,139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M296.73,139c-1.53,4.7-2.72,10.32-.54,13s7,.87,12,0c5.92-1,14.21-.89,24.86,4a8.62,8.62,0,0,0,.88-5c-1.14-7.11-13.48-9.73-19.46-11A58.64,58.64,0,0,0,296.73,139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M311,73c2.75-3.34,15.48,3.22,17,4,3.56,1.83,15.7,8.08,21,21,5.87,14.28,1.47,32.08-11,45a103.63,103.63,0,0,0-8-34C321.18,88.36,307.91,76.75,311,73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M310,50c7.07-7.86-1-22,3-24,6.87-3.43,44.77,32.51,35,58-6.9,18-34.45,22.69-48,25-25.05,4.27-32.14-3.76-54,3-8,2.48-24.53,7.58-35,23-15,22-6.43,48.76-5,53l-12,4c1.36-8.82-1.74-17.1-8-21-3.79-2.36-10.36-4.1-15-1s-4.94,10.17-5,13c-.38,18.54,18.35,23.52,27,48,4.42,12.5,4.81,26,2,27-3.35,1.16-9.75-16-24-36-21.15-29.72-32.91-28.32-41-44-17.5-33.92,8-97.65,51-120,20.59-10.71,51.82-15.12,80-11C283.67,50.32,302.08,58.8,310,50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M298,242c.56,1.67-7.46,10.63-17.31,11-11.12.42-20.28-10.27-19.67-12,.53-1.48,8,4.3,20.46,4C291.63,244.76,297.52,240.64,298,242Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M317,80l3,29"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M198,269l-25,32a108.78,108.78,0,0,0,9,38,110.17,110.17,0,0,0,34,43q10-23,20-46c-2.69-.37-23.33-3.6-35-23C188.56,292.31,197.09,271.15,198,269Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M252.75,175.67c.72-2-6-8.57-13.27-7.81-7.75.79-13,9.47-11.83,11.1.62.88,2.89-.62,8.73-1.77C246.68,175.17,252.15,177.35,252.75,175.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M321,177.57c1.14-1.82-4-9.67-11.25-10.52-7.73-.91-14.73,6.42-14,8.26.42,1,3,0,8.9.18C315.23,175.75,320.08,179.08,321,177.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M285,227c-5.68,1-7.76-5.48-16-8-4.18-1.28-6.64-.53-22,3s-23.19,5.32-25,5c-13.67-2.41-18.61-16.23-26-14-4.35,1.31-6.16,7.16-7,10-5.89,19.92,6.61,46.72,21,64,22.9,27.51,54.35,35.46,68,38a99.17,99.17,0,0,0,24-15c29.85-25.32,33.78-59.76,37-88,0,0,1.7-14.89-2-16-3-.89-6.16,8.69-17,13a26.85,26.85,0,0,1-9,2c-7.82.33-9.92-3.2-15-2C289.94,220.43,290.21,226.11,285,227Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M301,241c-.72-1.31-7.39,3.76-20,4-10.22.2-15.94-2.93-17-1-1.17,2.14,4.11,9.07,11,11C288,258.64,302.12,243,301,241Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M320.5,46.5c5.7,8.28,12.22,20.44,8,30-3.6,8.15-13.9,11.89-59,19-42.68,6.72-54.75,6.73-65,17-11,11-13,27-13,39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarHomme1);
export default __webpack_public_path__ + "static/media/avatar_homme_1.f8492908768d286f842a93d01a768b46.svg";
export { ForwardRef as ReactComponent };